"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _TypDokumentApi = require("./../api/gen/dokumenty/TypDokumentApi");

var _TypDokumentApi2 = _interopRequireDefault(_TypDokumentApi);

var _AbstractReactComponent = require("../AbstractReactComponent");

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _ObjectSuggestField = require("./ObjectSuggestField");

var _ObjectSuggestField2 = _interopRequireDefault(_ObjectSuggestField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Field pro výběr šablony.
 */
// --
var SablonaField = function (_AbstractReactCompone) {
    (0, _inherits3.default)(SablonaField, _AbstractReactCompone);

    function SablonaField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SablonaField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SablonaField.__proto__ || (0, _getPrototypeOf2.default)(SablonaField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            typDokumentKod: _this.props.typDokumentKod,
            list: null
        }, _this.requestData = function (typDokumentKod) {
            _this.setState({ typDokumentKod: typDokumentKod, list: null });
            _TypDokumentApi2.default.getSablonyProTypDokumentu(typDokumentKod).then(function (list) {
                if (typDokumentKod === _this.state.typDokumentKod) {
                    _this.setState({ list: list });
                }
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SablonaField, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var typDokumentKod = this.props.typDokumentKod;

            this.requestData(typDokumentKod);
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            var typDokumentKod = nextProps.typDokumentKod;

            if (typDokumentKod !== this.props.typDokumentKod) {
                this.requestData(typDokumentKod);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var list = this.state.list;
            var _props = this.props,
                typDokumentKod = _props.typDokumentKod,
                otherProps = (0, _objectWithoutProperties3.default)(_props, ["typDokumentKod"]);


            return _react2.default.createElement(_ObjectSuggestField2.default, (0, _extends3.default)({
                dropdown: true,
                removable: false,
                items: list,
                itemValueAttrName: "nazev"
            }, otherProps));
        }
    }]);
    return SablonaField;
}(_AbstractReactComponent2.default);

SablonaField.PropTypes = {
    typDokumentKod: _react2.default.PropTypes.string.isRequired
};
exports.default = SablonaField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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